// eslint-disable-next-line import/prefer-default-export
export const toCommaSeparated = number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
